import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyShoppingService } from '../../../shared/services/apis/platform/my-shopping.service';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { GetMyShoppingResponse, ShoppingItem } from '../../../shared/services/responses/platform/get-my-shopping-response';
import { MatDialog } from '@angular/material/dialog';
import { ModalRatingComponent } from './modal-rating/modal-rating/modal-rating.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-shopping',
  standalone: true,
  imports: [CommonModule, FormsModule, MenuComponent, FooterComponent, EmptyListComponent],
  templateUrl: './my-shopping.component.html',
  styleUrls: ['./my-shopping.component.css']
})
export class MyShoppingComponent implements OnInit {

  public shoppingResponse: GetMyShoppingResponse;
  public isLoading = true;

  constructor(
    private myShoppingService: MyShoppingService,
    private alertService: AlertService,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loadShoppingItems();
  }

  loadShoppingItems(): void {
    this.isLoading = true;
    this.myShoppingService.get().subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.shoppingResponse = response;
        this.isLoading = false;

        response.listShoppingItem = response.listShoppingItem.map(item => ({
          ...item,
          coverImageError: `https://placehold.co/400x600/${this.getRandomColor()}/fff?text=${encodeURIComponent(item.title || '')}`
        }));

        console.log(response.listShoppingItem)
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Não foi possível carregar suas compras.', AlertType.error);
        console.error(error);
      }
    });
  }

  stars(rating: number): boolean[] {
    return Array.from({ length: 5 }, (_, index) => index < (rating));
  }

  openPdf(url: string | null): void {
    if (url)
      window.open(url, '_blank');
  }

  viewDetails(idKitPaymentItem: number): void {
    this.router.navigate(['/minhas-compras/' + idKitPaymentItem]);
  }

  viewVideo(idKit: number): void {
    this.router.navigate(['/minhas-compras/videos/' + idKit]);
  }

  rateNow(idBook: number, idKitPaymentItem: number) {
    const dialogRef = this.dialog.open(ModalRatingComponent, {
      width: '400px',
      data: { idBook, idKitPaymentItem }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadShoppingItems();
      }
    });
  }

  private getRandomColor(): string {
    const colors = ['333', '8fbc8f', '4682b4', '6a5acd', 'd2691e'];
    return colors[Math.floor(Math.random() * colors.length)];
  }
}